import React from "react";
import { Typography, Box, ListItem } from "@material-ui/core";
import PropTypes from 'prop-types';
import { useTranslate } from 'react-admin'
import { getTimeDayMonth, getFullTime, SCHEDULE_TYPE } from '../utils';
import Checkbox from '../checkbox';
import classnames from 'classnames';

function Index({ item, classes, onCheckboxClick, isDelete }) {
    const translate = useTranslate()

    return (
        <ListItem className={classes.root} button>
            <Box flex={0.5} className={classes.childItem} px={1}>
                {
                    isDelete &&
                    <Checkbox onClick={onCheckboxClick} checked={item.checked === true ? true : false} />
                }
            </Box>
            <Box flex={4} className={classnames(classes.childItem, classes.subjectText)}>
                <Typography className={classes.subjectText} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 400 }}>{item.subject}</Typography>
            </Box>
            <Box flex={1} className={classes.childItem}>
                <Typography className={classes.anotherText}>{getTimeDayMonth(item.timeSent, translate)}</Typography>
            </Box>
            <Box flex={1} className={classes.childItem}>
                <Typography className={classes.anotherText}>{item.scheduleType === SCHEDULE_TYPE.OTHER ? getFullTime(item.schedule) : ''}</Typography>
            </Box>
            <Box flex={0.5}></Box>
        </ListItem>
    );
}

Index.propTypes = {
    item: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    onCheckboxClick: PropTypes.func.isRequired
};

export default Index;
